import CardDiv from "modules/common/card-div/CardDiv";
import ActionableCustomerList from "modules/dashboards/actionable_list/ActionableCustomerList";
import React, { useEffect, useState } from "react";
import { useIVREngagements } from "./store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import moment from "moment";
import useActionableListStore from "modules/dashboards/actionable_list/store";
import { currentUser, getCurrentUserRole } from "modules/utilities/utility";
import DatePicker from "react-datepicker";
import { Tabs } from "antd";
import { paginationData } from "modules/engagement_report/engagement_reports/engagement_cf";
import { RECEPTIONINST } from "modules/utilities/utility_2";
import _ from "lodash";

function ReceptionistTodayEngagement() {
    const { fetchIVRBooking, IVRBookingData, IVRLoading } = useIVREngagements();
    const [userData, setUserData] = useState([]);
    const [page, newPage] = useState(1);
    const [filterData, setFilter] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [leadPage, leadNewPage] = useState(1);
    const [leadFilterData, setLeadFilter] = useState([]);
    const [leadPageCount, setLeadPageCount] = useState(1);
    const [attemptPage, attemptNewPage] = useState(1);
    const [attemptFilterData, setAttemptFilter] = useState([]);
    const [attemptPageCount, setAttemptPageCount] = useState(1);
    const [showCustomerInFull, setShowCustomerInFull] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("All");
    const [tabFilteredData, setTabFilteredData] = useState([]);

    const start = moment().subtract(14, "days").startOf("day").toISOString();
    const end = moment().endOf("day").toISOString();
    const [startDate, setStartDate] = useState(
        moment().startOf("day").subtract(14, "days").toDate()
    );
    const [endDate, setEndDate] = useState(moment().endOf("day").toDate());

    const {
        todayEngData,
        todayLoading,
        fetchTodayEngData,
        fetchTempEngData,
        fetchLeadTempData,
        tempLeadData,
        tempEngData,
    } = useActionableListStore();

    const [submitFlag, setSubmitFlag] = useState(0);
    const [leadUserData, setLeadUserData] = useState([]);
    const [reAttempt, setReAttempt] = useState([]);

    const leadAgent = ["lead_agent"];
    const agent = ["sales", "lead_agent"];
    const med = ["medical"];

    // Tab categories
    const tabCategories = [
        "All",
        "Prescription Call",
        "Week #1",
        "Week #3",
        "retention",
        "SLOT_BOOKING",
        "IVR_BOOKING",
        "FEEDBACK_CALL",
        "ADHOC_CALL",
        "abandoned_cart",
        "w0_call",
        "scalpie_update",
        "kit_not_started",
        "CUSTOMER_COMPLAINT_BOOKING",
        "SLOT_BOOKING_MEDICAL",
    ];

    const getReceptionistData = (tag) => {
        const tagFilter = tag === "All" ? null : tag;
        fetchTodayEngData(tagFilter);
        fetchTempEngData(tagFilter);
    };

    // Initial data fetch and re-fetch on tab change or submit
    useEffect(() => {
        setIsLoading(true);
        if (agent.includes(getCurrentUserRole())) {
            fetchTodayEngData();
            fetchLeadTempData();
        } else if (med.includes(currentUser) && startDate && endDate) {
            fetchIVRBooking(startDate, endDate);
        } else if (RECEPTIONINST) {
            getReceptionistData(activeTab);
        } else {
            fetchIVRBooking(start, end);
        }
    }, [submitFlag, activeTab]);

    // Process data when it arrives
    useEffect(() => {
        if (agent.includes(getCurrentUserRole())) {
            if (["lead_agent"].includes(currentUser)) {
                const allUserData = [...(todayEngData || []), ...(tempLeadData || [])];
                const filterColdCall = allUserData?.filter(
                    (item) =>
                        item.request_type !== "lead_cold_slot" &&
                        (item?.unanswered_count === 0 && item?.reschedule_count === 0 ||
                            item?.unanswered_count !== item?.reschedule_count)
                );
                const leadCall = allUserData?.filter((item) => item.request_type === "lead_cold_slot");
                const reAttemptData = allUserData?.filter(
                    (item) => item?.unanswered_count > 0 && item?.reschedule_count > 0
                );

                const sortByReminderDate = (data) => {
                    return [...data].sort(
                        (dateOne, dateTwo) =>
                            new Date(dateTwo?.reminder_date) - new Date(dateOne?.reminder_date)
                    );
                };

                setReAttempt(sortByReminderDate(reAttemptData));
                setUserData(sortByReminderDate(filterColdCall));
                setLeadUserData(sortByReminderDate(leadCall));
            } else {
                setUserData(todayEngData || []);
            }
        } else if (RECEPTIONINST) {
            setUserData([...(todayEngData || []), ...(tempEngData || [])]);
        } else if (["chat_call_agent"].includes(currentUser)) {
            setUserData(todayEngData || []);
        } else {
            setUserData(IVRBookingData || []);
        }

        setIsLoading(false);
    }, [IVRBookingData, todayEngData, tempLeadData, tempEngData]);

    useEffect(() => {
        async function calculate() {
            paginationData(leadUserData, setLeadPageCount, setLeadFilter, leadPage);
        }
        if (!_.isEmpty(leadUserData)) {
            calculate();
        }
    }, [leadUserData, leadPage]);

    useEffect(() => {
        async function calculate() {
            paginationData(userData, setPageCount, setFilter, page);
        }
        if (!_.isEmpty(userData)) {
            calculate();
        }
    }, [userData, page]);

    useEffect(() => {
        async function calculate() {
            paginationData(reAttempt, setAttemptPageCount, setAttemptFilter, attemptPage);
        }
        if (!_.isEmpty(reAttempt)) {
            calculate();
        }
    }, [reAttempt, attemptPage]);

    // Filter data based on active tab
    useEffect(() => {
        if (filterData && filterData.length > 0) {
            if (activeTab === "All") {
                setTabFilteredData(filterData);
            } else {
                const filtered = filterData.filter((item) => item.tag === activeTab);
                setTabFilteredData(filtered);
            }
        } else {
            setTabFilteredData([]);
        }
    }, [filterData, activeTab]);

    const handleSubmit = () => {
        setSubmitFlag(submitFlag + 1);
    };

    const handleClear = () => {
        setStartDate(moment().startOf("day").subtract(14, "days").toDate());
        setEndDate(moment().endOf("day").toDate());
        setSubmitFlag(submitFlag + 1);
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const loading = isLoading || (agent.includes(getCurrentUserRole()) ? todayLoading : IVRLoading);

    // Generate tab items from the categories
    const tabItems = tabCategories.map((category) => {
        return {
            key: category,
            label: (
                <span>
                    {category}
                </span>
            ),
        };
    });

    return (
        <div>
            <CardDiv
                title={
                    med.includes(currentUser) ? (
                        <div className="d-flex justify-content-between">
                            <div>Medicals Engagement</div>
                            <div className="d-flex gap-2" style={{ zIndex: "999" }}>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    formatWeekDay={(day) => day.slice(0, 3)}
                                    className="form-control"
                                    placeholderText="Select previous Date"
                                />
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    formatWeekDay={(day) => day.slice(0, 3)}
                                    className="form-control"
                                    placeholderText="Select previous Date"
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "2.26rem" }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "2.26rem" }}
                                    onClick={handleClear}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    ) : (
                        "Today Engagements"
                    )
                }
                component={
                    <>
                        <Tabs
                            activeKey={activeTab} // Use activeKey to control the active tab
                            items={tabItems}
                            onChange={handleTabChange}
                            type="card"
                            className="mb-4"
                        />
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="mt-2">Loading engagement data...</div>
                            </div>
                        ) : !userData.length && !leadUserData.length && !reAttempt.length ? (
                            <div className="text-center py-4">
                                <div className="alert alert-info" role="alert">
                                    No engagement data available
                                </div>
                            </div>
                        ) : leadAgent.includes(currentUser) ? (
                            <div>
                                <ActionableCustomerList
                                    actionableData={tabFilteredData}
                                    actionableTabs={true}
                                    actionableLoading={loading}
                                    showCustomerInFull={showCustomerInFull}
                                    setShowCustomerInFull={setShowCustomerInFull}
                                />
                                <div className="mt-3" style={{ width: "30%" }}>
                                    {!showCustomerInFull && tabFilteredData.length > 0 ? (
                                        <PaginationDiv
                                            newPage={newPage}
                                            paginationData={{ pageCount: pageCount || 1, page: page }}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        ) : (
                            <div>
                                <ActionableCustomerList
                                    actionableData={tabFilteredData}
                                    actionableTabs={true}
                                    actionableLoading={loading}
                                    showCustomerInFull={showCustomerInFull}
                                    setShowCustomerInFull={setShowCustomerInFull}
                                />
                                <div className="mt-3" style={{ width: "30%" }}>
                                    {!showCustomerInFull && tabFilteredData.length > 0 ? (
                                        <PaginationDiv
                                            newPage={newPage}
                                            paginationData={{ pageCount: pageCount || 1, page: page }}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        )}
                    </>
                }
            />
        </div>
    );
}

export default ReceptionistTodayEngagement;